<template>
  <div class="admin__a-tab-content admin__a-tab-content--show">
    <br>
    <specifiсation-table :lot="lot" :retend="retend"></specifiсation-table>

    <br>

    <payments-and-parts :retend="retend" :lot="lot"></payments-and-parts>
  </div>
</template>

<script>
  import SpecifiсationTable from './SpecificationTable'
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'
  import PaymentsAndParts from "../../lot-details/blocks/PaymentsAndParts";

  export default {
    components: {
      PaymentsAndParts,
      SpecifiсationTable
    },

    props: {
      retend: Object,
      lot: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    validations: {
      retend: {
        parts: {
          $each: {
            deliveryDate: {
              validDate(value, part) {

                if (part.deliveryDate && part.minDeliveryDate && part.deliveryDate < part.minDeliveryDate) return false;
                return true;
              }
            },

            acceptingDate: {
              validDate(value, part) {
                return !part.deliveryDate || part.acceptingDate >= part.deliveryDate
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
